import { render, staticRenderFns } from "./CourseAssignment.vue?vue&type=template&id=a3ef6d6a&scoped=true"
import script from "./CourseAssignment.vue?vue&type=script&lang=js"
export * from "./CourseAssignment.vue?vue&type=script&lang=js"
import style0 from "./CourseAssignment.vue?vue&type=style&index=0&id=a3ef6d6a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3ef6d6a",
  null
  
)

export default component.exports